import { createFileRoute, Link } from "@tanstack/react-router";
import { btn } from "@/components/ds/styles";
import { RouteError, RouteNotFound } from "@/components/route-boundaries";

export const Route = createFileRoute("/_public/share/reports/$token")({
  head: () => ({
    meta: [
      { title: "انتهت صلاحية هذا الرابط — بوصلة د. سارة" },
      { name: "robots", content: "noindex, nofollow, noarchive, nosnippet" },
    ],
  }),
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: ExpiredSharePage,
});

/**
 * The shared parent letter was retired. Old links stay reachable so parents get
 * a clear message instead of a 404 — this page reads nothing from the database.
 */
function ExpiredSharePage() {
  return (
    <div className="bg-cream-200 px-5 py-16" dir="rtl">
      <div className="mx-auto max-w-xl">
        <p className="font-display text-[14px] font-bold text-amber-800">رابط مشاركة</p>
        <h1 className="mt-2 font-display text-[34px] font-extrabold leading-[1.25] text-text-primary">انتهت صلاحية هالرابط</h1>
        <p className="mt-3 text-[17px] leading-[1.85] text-brown-500">
          هالصفحة ما عاد فيها تنعرض. لتقرير ابنكم أو بنتكم، التواصل مع عيادة د. سارة النحّاس.
        </p>
        <Link to="/contact" className={`${btn.primary} mt-6`}>
          التواصل مع العيادة ←
        </Link>
      </div>
    </div>
  );
}
